import { useState, useEffect } from "react";
import "./BidWaitingTimer.css";
import Image1 from "../image/timer-1.svg";
import Image2 from "../image/timer-2.svg";

export default function BidWaitingTimer() {
    const [timeLeft, setTimeLeft] = useState(60);
    const [toggle, setToggle] = useState(true);

    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setInterval(() => setTimeLeft((t) => t - 1), 1000);
            return () => clearInterval(timer);
        }
    }, [timeLeft]);

    // Image toggle timer (every 3 sec)
    useEffect(() => {
        const imgTimer = setInterval(() => {
            setToggle((prev) => !prev);
        }, 3000); // 3000 ms = 3 sec

        return () => clearInterval(imgTimer);
    }, []);

    return (
        <div className="BidWaitingTimer-container">
            {toggle ? (
                <>
                    <h2 className="BidWaitingTimer-title">
                        Just 60 Seconds Away From Your Lead
                    </h2>
                </>
            ) : (
                <>
                    <h2 className="BidWaitingTimer-title">
                        Your lead is unlock in 60 second!
                    </h2>
                    <p className="BidWaitingTimer-subtitle">
                        Hold tight, something exciting is on the way
                    </p>
                </>
            )}



            <div className="BidWaitingTimer-circle">
                <svg className="BidWaitingTimer-ring" width="120" height="120">
                    <circle
                        className="BidWaitingTimer-ring-bg"
                        stroke="rgba(255,255,255,0.3)"
                        strokeWidth="20"
                        fill="transparent"
                        r="50"
                        cx="60"
                        cy="60"
                    />
                    <circle
                        className="BidWaitingTimer-ring-progress"
                        stroke="#fff"
                        strokeWidth="20"
                        fill="transparent"
                        r="50"
                        cx="60"
                        cy="60"
                        style={{
                            strokeDasharray: `${2 * Math.PI * 50}`,
                            strokeDashoffset: `${(2 * Math.PI * 50 * (60 - timeLeft)) / 60
                                }`,
                        }}
                    />
                </svg>
                <span className="BidWaitingTimer-text">{timeLeft}</span>
            </div>

            <div className="BidWaitingTimer-illustrations">
                {toggle ? <img src={Image2} alt="" /> : <img src={Image1} alt="" />}
            </div>
        </div>
    );
}
